<template>
  <v-dialog
    :value="editingEmail"
    @update:return-value="closeDialog"
    max-width="500"
  >
    <v-card>
      <v-form ref="emailForm" @submit.prevent="updateEmail" v-model="valid">
        <v-card-title> Edit Email </v-card-title>
        <v-card-text class="body-1">
          <v-alert dense dismissible type="error" v-if="showError">{{
            errorMessage
          }}</v-alert>
          <p class="overline mb-2">Current Email</p>
          <p class="text-truncate">
            {{ email }}
          </p>
          <p class="overline mb-2">New Email</p>
          <v-text-field
            outlined
            dense
            v-model="newEmail"
            :rules="[
              rules.required,
              rules.email,
              rules.newEmail(email, newEmail),
            ]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeDialog" color="error">Close</v-btn>
          <v-btn type="submit" color="info" @click="validate">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChangeEmailDialog',
  props: {
    email: {
      type: String,
    },
    editingEmail: {
      type: Boolean,
    },
    showError: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
    },
  },
  data: () => ({
    valid: false,
    newEmail: null,

    showSuccess: false,
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        const pattern =
          /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
        return pattern.test(value) || 'Must be a valid email'
      },
      newEmail: (currentEmail, newEmail) => {
        return currentEmail !== newEmail || "New email can't match old email"
      },
    },
  }),
  methods: {
    validate() {
      this.$refs.emailForm.validate()
    },
    reset() {
      this.editingEmail = false
      this.$refs.emailForm.reset()
    },
    updateEmail() {
      if (this.valid) {
        this.$emit('updateEmail', this.newEmail)
      }
    },
    closeDialog() {
      this.reset()
      this.$emit('onDialogClosed')
    },
  },
}
</script>

<style scoped></style>
